import classNames from 'classnames';
import { withFormik } from 'formik';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { getDrivers } from '../../services/api/drivers';
import { getRegistrations } from '../../services/api/registrations';
import '../../styles/vendor/react-checkbox-tree.css';
import BasicInput from './fields/BasicInput';
import BasicSelect from './fields/BasicSelect';
import CustomDatePicker from './fields/CustomDatePicker';
import CrewMemberSelect from './reusable/CrewMemberSelector';
import CompanySelector from './reusable/companySelector';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drivers: [],
      timeslots: [1],
      deletedTimeslots: [],
      registration: null,
      crewMember: null,
      usingCrewMember: true,
    };

    this._getDrivers = this._getDrivers.bind(this);
    this._addRow = this._addRow.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    profile: PropTypes.object,
    setValues: PropTypes.func,
    isCreating: PropTypes.bool,
    setFieldValue: PropTypes.func,
    admin: PropTypes.bool,
    registration: PropTypes.object,
    event: PropTypes.object,
    values: PropTypes.object,
    locations: PropTypes.array,
  };

  UNSAFE_componentWillMount() {
    if (!this.props.admin) {
      this._getDrivers();
    }

    if (this.props.registration) {
      this.setState({ registration: this.props.registration });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentProps = this.props;

    if (currentProps.values.driverId !== nextProps.values.driverId) {
      if (nextProps.values.driverId === '') {
        currentProps.setFieldValue('driverName', '');
        currentProps.setFieldValue('driverTelephone', '');
        currentProps.setFieldValue('truckType', '');
        currentProps.setFieldValue('licensePlate', '');
      } else {
        const driver = this.state.drivers[nextProps.values.driverId];
        currentProps.setFieldValue('driverName', driver.name);
        currentProps.setFieldValue('driverTelephone', driver.telephone);
        currentProps.setFieldValue('truckType', driver.truckType);
        currentProps.setFieldValue('licensePlate', driver.licensePlate);
      }
    }

    // Company selector changed
    if (currentProps.values.companyId !== nextProps.values.companyId) {
      if (!nextProps.values.companyId) {
        currentProps.setFieldValue('registrationId', '');
        this.setState({ registration: null });

        return;
      }

      getRegistrations({
        'include': 'company',
        'filter[event_id]': this.props.event.id,
        'filter[company_id]': nextProps.values.companyId,
      }).then((response) => {
        if (response.data[0]) {
          currentProps.setFieldValue('registrationId', response.data[0].id);
          this.setState({ registration: response.data[0] });
        }
      });
    }

    if (currentProps.values.locationId !== nextProps.values.locationId && nextProps.values.locationId) {
      currentProps.setFieldValue(
        'gate',
        currentProps.locations.filter((location) => location.id === parseInt(nextProps.values.locationId, 10))[0].gate
          .name
      );
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      currentProps.resetForm();
      this.setState({ occupations: [] });
    }
  }

  _getDrivers() {
    getDrivers(this.props.registration.companyId).then((response) => {
      this.setState({
        drivers: response.data,
      });
    });
  }

  _getTimes() {
    let times = [];
    for (let h = 6; h < 24; h++) {
      const fullH = h < 10 ? '0' + h : h;
      times.push(fullH + ':00');
      times.push(fullH + ':30');
    }
    times.splice(-1, 1);
    return times.map((time) => {
      return {
        value: time,
        title: time,
      };
    });
  }

  _addRow() {
    const timeslots = [].concat(this.state.timeslots);
    timeslots.push(this.state.timeslots.length + 1);
    this.setState({
      timeslots,
    });

    this.props.setFieldValue('times', timeslots.length);
  }

  _deleteTimeslot(timeslot) {
    const newDeleted = [timeslot].concat(this.state.deletedTimeslots);
    this.setState({
      deletedTimeslots: newDeleted,
    });

    this.props.setFieldValue('deletedTimes', newDeleted);
  }

  _handleCrewMemberChange(crewMember) {
    this.setState({ crewMember });
  }

  _usingCrewMember(usingCrewMember) {
    if (!usingCrewMember) {
      this.props.setFieldValue('crewMemberId', '');
      this.setState({ crewMember: null, usingCrewMember: false });
    } else {
      this.props.setFieldValue('driverId', '');
      this.props.setFieldValue('driverName', '');
      this.props.setFieldValue('driverTelephone', '');
      this.setState({ usingCrewMember: true });
    }
  }

  render() {
    const props = this.props;
    const { timeslots, deletedTimeslots, drivers, registration, crewMember, usingCrewMember } = this.state;
    const { event, locations, admin } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="mx-4">
          {admin && [
            <CompanySelector
              key="selector"
              filters={{ 'filter[registered_for_event_id]': event.id }}
              {...props}
              name="companyId"
            />,
            <div className="m-form__seperator m-form__seperator--dashed" key="separator" />,
          ]}
        </div>

        {registration && (
          <>
            <div className="modal-body">
              <h4>Driver</h4>
              <p>Select a crew member or enter a driver manually.</p>
            </div>

            <ul className="pl-4 mb-0 nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  onClick={() => this._usingCrewMember(true)}
                  className={classNames('nav-link', { active: usingCrewMember })}
                  data-toggle="tab"
                  href="#"
                >
                  Crew Member
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => this._usingCrewMember(false)}
                  className={classNames('nav-link', { active: !usingCrewMember })}
                  data-toggle="tab"
                  href="#"
                >
                  Manual Entry
                </a>
              </li>
            </ul>
            <div className="modal-body">
              {usingCrewMember && (
                <>
                  <CrewMemberSelect
                    {...props}
                    registration={registration}
                    name="crewMemberId"
                    labelFn={(crewMember) =>
                      `${crewMember.user?.fullName} ${crewMember.user?.telephone ? `(${crewMember.user.telephone})` : ''}`
                    }
                    onChange={(crewMember) => this._handleCrewMemberChange(crewMember)}
                  />
                </>
              )}

              {!usingCrewMember && (
                <>
                  <BasicSelect
                    {...props}
                    name="driverId"
                    label="Driver"
                    options={[
                      {
                        value: '',
                        title: 'New driver',
                      },
                    ].concat(
                      drivers.map((driver, index) => {
                        return {
                          value: index,
                          title: `${driver.name} (${driver.truckType})`,
                        };
                      })
                    )}
                  />

                  <div>
                    <BasicInput
                      {...props}
                      name="driverName"
                      type="text"
                      label="Driver Name"
                      disabled={props.values.driverId !== ''}
                    />
                    <BasicInput
                      {...props}
                      name="driverTelephone"
                      type="text"
                      label="Driver Telephone"
                      disabled={props.values.driverId !== ''}
                    />
                  </div>
                </>
              )}

              <div className="m-form__seperator m-form__seperator--dashed" />

              <h4>Vehicle Details</h4>

              <BasicSelect
                {...props}
                disabled={props.values.driverId !== ''}
                name="truckType"
                label="Vehicle type"
                placeholder={'Select your vehicle type...'}
                options={[
                  {
                    value: 'car',
                    title: 'Car',
                  },
                  {
                    value: 'motorcycle',
                    title: 'Motorcycle',
                  },
                  {
                    value: 'minivan',
                    title: 'Minivan',
                  },
                  {
                    value: 'van',
                    title: 'Van',
                  },
                  {
                    value: 'single axe',
                    title: 'Single Axe',
                  },
                  {
                    value: 'double axe',
                    title: 'Double Axe',
                  },
                  {
                    value: 'exceptional transport',
                    title: 'Exceptional Transport',
                  },
                ]}
              />

              <BasicInput
                {...props}
                name="licensePlate"
                type="text"
                label="License plate"
                help="Use any format you like, e.g. 1-ABC-123 or 1ABC123"
              />

              <div className="m-form__seperator m-form__seperator--dashed" />

              <h4>Location</h4>

              <BasicSelect
                {...props}
                name="locationId"
                label="Destination"
                placeholder={'select your destination on site.'}
                options={locations.map((location) => {
                  return {
                    value: location.id,
                    title: `${location.name} (via ${location.gate.name})`,
                  };
                })}
              />

              <div className="m-form__seperator m-form__seperator--dashed" />
              <div className="row m--margin-top-20 m--margin-bottom-10">
                <div className="col-lg-6">
                  <h4>Times</h4>
                </div>
                <div className="col-lg-6 m--align-right">
                  <button type="button" className="btn btn-outline-info" onClick={this._addRow}>
                    <i className="la la-plus mr-1" />
                    Add transport
                  </button>
                </div>
              </div>

              {timeslots.map((timeslot, index) => {
                if (deletedTimeslots.indexOf(timeslot) === -1) {
                  return (
                    <div key={timeslot} className="mb-4">
                      <h6 className="text-uppercase">Transport #{index + 1}</h6>
                      <div className="grid grid-auto-cols-max grid-flow-col gap-4 items-center">
                        <div>
                          <CustomDatePicker
                            {...props}
                            name={'date_' + timeslot}
                            minDate={moment(event.startsAt)}
                            maxDate={moment(event.endsAt)}
                            showMonthDropdown
                          />
                        </div>
                        <div>
                          <label className="mb-0">
                            <input
                              {...props}
                              name={'all_day_' + timeslot}
                              className="me-2"
                              type="checkbox"
                              value={true}
                              onChange={(e) => props.setFieldValue('all_day_' + timeslot, e.target.checked)}
                            />
                            Entire day
                          </label>
                        </div>
                        <div>
                          <BasicSelect
                            {...props}
                            name={'time_' + timeslot}
                            placeholder="Select a time"
                            options={this._getTimes()}
                            disabled={props.values['all_day_' + timeslot]}
                          />
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-block"
                            onClick={() => this._deleteTimeslot(timeslot)}
                          >
                            <i className="la la-trash mr-1" />
                            <span>Delete</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                }

                return null;
              })}
            </div>
          </>
        )}
        <div className="modal-footer">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                key="1"
                className={
                  'btn m-btn btn-primary' +
                  (props.isSubmitting ? ' m-btn--custom m-loader m-loader--light m-loader--left' : '')
                }
                disabled={props.isSubmitting}
              >
                {props.profile ? 'Update' : 'Create'}
              </button>

              {props.profile && (
                <span key="2" className="m--margin-left-10">
                  or{' '}
                  <Link to="/profile-groups" className="m-link m--font-bold">
                    Cancel
                  </Link>
                </span>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const TransportEventForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      crewMemberId: '',
      driverId: '',
      driverName: '',
      driverTelephone: '',
      truckType: '',
      licensePlate: '',
      locationId: '',
      gate: '',
      times: 1,
      deletedTimes: [],
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (props.admin && (!values.companyId || values.companyId === '')) {
      errors.companyId = 'required';
    }

    // If there is no crew member -> driverName and driverTelephone are required
    if (
      !values.crewMemberId &&
      (!values.driverName || values.driverName === '' || !values.driverTelephone || values.driverTelephone === '')
    ) {
      if (!values.driverName || values.driverName === '') {
        errors.driverName = 'required';
      }

      if (!values.driverTelephone || values.driverTelephone === '') {
        errors.driverTelephone = 'required';
      }

      if (!values.crewMemberId) {
        errors.crewMemberId = 'required';
      }
    }

    if (!values.truckType || values.truckType === '') {
      errors.truckType = 'required';
    }

    if (!values.locationId || values.locationId === '') {
      errors.locationId = 'required';
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values).then((response) => resetForm());
  },
})(InnerForm);

export default TransportEventForm;
